import { DeleteIcon, EditIcon, ResourceMenuActions } from '@all-manager/design-system-v2';
import { ProviderDatabase } from "../../../../types";
import AddUpdateProviderModal from "../AddUpdateProviderModal/AddUpdateProviderModal";
import DeleteProviderModal from "../DeleteProviderModal/DeleteProviderModal";
import { useProviderMenuAction } from "./useProviderMenuAction";

type Props = {
  provider: ProviderDatabase;
  afterDeletionSuccess?: () => void;
  size?: 'small' | 'medium';
}

export default function ProviderMenuAction(props: Props) {
  const hook = useProviderMenuAction();

  return (
    <>
      <ResourceMenuActions
        size={props.size ?? 'small'}
        tooltip={`Options de ${props.provider.name}`}
        actions={[
          {
            id: 'edit',
            label: 'Modifier',
            icon: <EditIcon fontSize="small" />,
            onClick: hook.handleOpenUpdateModal,
          },
          {
            id: 'delete',
            label: 'Supprimer',
            icon: <DeleteIcon fontSize="small" />,
            onClick: hook.handleOpenDeleteModal,
          },
        ]}
      />

      {hook.isUpdateModalOpen ? (
        <AddUpdateProviderModal
          provider={props.provider}
          onClose={hook.handleCloseUpdateModal}
        />
      ) : null}

      {hook.isDeleteModalOpen ? (
        <DeleteProviderModal
          provider={props.provider}
          onClose={hook.handleCloseDeleteModal}
          afterSuccess={props.afterDeletionSuccess}
        />
      ) : null}
    </>
  );
}
